import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import * as types from "./monitor.types";

export const initialState: types.InitialState = {
    monitorData: {
        M_Group: "",
        Adult_svy_yr: "",
        Youth_svy_yr: "",
        Adult_svy_national: "",
        Youth_svy_national: "",
        Periodic_Adult: "",
        Periodic_Youth: "",
        Adult_svy_age_range: "",
        Youth_svy_age_range: "",
        monitorPropData: [],
    },
};

const monitorInfo = createSlice({
    name: "monitorInfo",
    initialState,
    reducers: {
        getMonitorInfo: (state, _action) => {
            return { ...state };
        },

        getMonitorInfoSuccess: (
            state,
            action: PayloadAction<types.MonitorDataInfoType>,
        ) => {
            return {
                ...state,
                monitorData: action.payload,
            };
        },

        getMonitorInfoError: (state) => {
            return {
                ...state,
            };
        },
    },
});

export const { getMonitorInfo, getMonitorInfoSuccess, getMonitorInfoError } =
    monitorInfo.actions;

export default monitorInfo.reducer;
